import { useCallback } from "react";
import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana2Div3M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandById = (id) => {
    return lands.filter((l) => l.id === id)[0];
  };
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };
  const getFill = useCallback(
    (id, selected2) => {
      const land = lands.find((l) => l.id === id);
      const disabledColor = "#6F8789";
      const normalColor = "#0096B3";
      const selectedColor = "#5AE5F4";

      if (!land) {
        return disabledColor; // disabled
      }

      if (selected) {
        if (id === selected.id) {
          return selectedColor;
        }
      }

      if (land.status !== "on_sale") {
        return disabledColor; // disabled
      } else {
        return normalColor; // normal color
      }
    },
    [lands, selected]
  );

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_43458)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("29"))}
        d="M580.605 292.672L595.157 233.006L509.296 222.819L497.654 272.298L580.605 292.672Z"
        fill={getFillByLot(29, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("28"))}
        d="M567.499 349.426L580.596 292.671L497.646 272.297L484.549 324.686L567.499 349.426Z"
        fill={getFillByLot(28, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("27"))}
        d="M552.954 406.183L567.507 349.428L484.557 324.688L468.549 381.444L552.954 406.183Z"
        fill={getFillByLot(27, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("26"))}
        d="M539.855 461.479L552.952 406.179L468.547 381.439L453.994 436.74L539.855 461.479Z"
        fill={getFillByLot(26, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("25"))}
        d="M437.99 493.5L453.998 436.745L539.859 461.484L523.851 516.784L437.99 493.5Z"
        fill={getFillByLot(25, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        d="M421.98 550.256L437.988 493.501L523.849 516.785L510.752 572.085L421.98 550.256Z"
        fill={getFillByLot(24, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        d="M408.887 605.56L421.984 550.26L510.755 572.089L497.658 627.389L408.887 605.56Z"
        fill={getFillByLot(23, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        d="M484.564 684.135L497.662 627.379L408.89 605.55L395.793 662.306L484.564 684.135Z"
        fill={getFillByLot(22, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        d="M475.829 729.251L484.56 684.138L395.789 662.309L379.781 730.707C397.244 735.072 434.79 743.222 451.089 746.715C467.388 750.207 474.374 736.528 475.829 729.251Z"
        fill={getFillByLot(21, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_43458"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_43458"
            transform="matrix(0.00199613 0 0 0.00264577 -3.56251 -0.409338)"
          />
        </pattern>
        <image
          id="image0_1468_43458"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
